exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-goods-container .overflow-on .cell[data-v-4f6e11c4]{overflow:visible;overflow-x:visible;overflow-y:visible}.point-goods-container .el-table__row button[data-v-4f6e11c4]{margin:5px}\n", ""]);

// exports
